export default __webpack_public_path__ + "static/media/ted.747da84e.jpg";